module.exports = __webpack_public_path__ + "img/logo-company-white.8c0a02ed.svg";